<template>
  <div class="page" :class="{ mobile: isMobile }">
    <div class="wrap">
      <!-- 顶部栏（桌面端）；移动端顶栏在舞台内，避免 requestFullscreen 后固定栏被挡在层外 -->
      <div v-if="!isMobile" class="top">
        <div class="brand">
          <svg
            t="1776082086858"
            class="back-icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3195"
            width="200"
            height="200"
            role="button"
            aria-label="结束面试并返回"
            tabindex="0"
            @click="handleEndInterviewClick"
            @keydown.enter.prevent="handleEndInterviewClick"
            @keydown.space.prevent="handleEndInterviewClick"
          >
            <path
              d="M210.4 511.1 641.3 80.2c22.8-22.8 59.8-22.8 82.6 0 22.8 22.8 22.8 59.8 0 82.6L375.7 511.1l348.3 348.3c22.8 22.8 22.8 59.8 0 82.6-22.8 22.8-59.8 22.8-82.6 0L210.4 511.1 210.4 511.1zM210.4 511.1"
              p-id="3196"
            ></path>
          </svg>
          <img class="logo" src="/word_header_logo.png" alt="" aria-hidden="true" />
          <div>
            <div class="title">{{ candidateName }}面试间 · 面试官</div>
          </div>
        </div>

        <div v-if="!roomClosingUiHidden" class="indicator-group">
          <div class="pill" title="面试计时">
            <span aria-hidden="true">⏱️</span>
            <span>{{ timerText }}</span>
          </div>
          <div class="pill" title="录制状态">
            <span :class="['status-dot', recStatusClass]"></span>
            <span>{{ recText }}</span>
          </div>
          <div class="pill" title="网络状态">
            <span :class="['status-dot', netOk ? 'ok' : 'bad']"></span>
            <span>{{ netOk ? "网络：正常" : "网络：已断开" }}</span>
          </div>
          <el-button size="small" native-type="button" class="primary deskFullscreenBtn" @click="toggleFullscreen">
            {{ isFs ? "退出全屏" : "全屏" }}
          </el-button>
          <el-button style="margin-left: 0px;" size="small" native-type="button" class="danger" @click="handleEndInterviewClick">结束面试</el-button>
        </div>
      </div>

      <!-- 视频主区域 -->
      <div class="main">
        <div class="card" :class="{ mobileCard: isMobile }">
          <div v-if="!isMobile && !roomClosingUiHidden" class="cardH">
            <strong>🎥 视频区域</strong>
            <div class="btnRow">
              <el-button size="small" native-type="button" :disabled="!stream" @click="toggleMic">
                {{ micOn ? "静音麦克风" : "取消静音" }}
              </el-button>
              <el-button size="small" native-type="button" :disabled="!stream" @click="toggleCam">
                {{ camOn ? "关闭摄像头" : "开启摄像头" }}
              </el-button>
              <el-button size="small" native-type="button" @click="toggleScreenShare">
                {{ screenShared ? "停止共享" : "共享屏幕" }}
              </el-button>
            </div>
          </div>
          <div class="cardB" :class="{ mobileCardB: isMobile }">
            <div class="stage" ref="stage" @click="handleStageTap">
              <!-- 移动端顶栏在舞台内，与底部栏共用 mobileControlsVisible 显隐；全屏后仍能看见 -->
              <div
                v-if="isMobile && !roomClosingUiHidden"
                class="stageMobileTopBar"
                :class="{ hide: !mobileControlsVisible }"
                @click.stop
              >
                <div class="brand">
                  <svg
                    t="1776082086858"
                    class="back-icon mobileBackIcon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="3195"
                    width="200"
                    height="200"
                    role="button"
                    aria-label="结束面试并返回"
                    tabindex="0"
                    @click="handleEndInterviewClick"
                    @keydown.enter.prevent="handleEndInterviewClick"
                    @keydown.space.prevent="handleEndInterviewClick"
                  >
                    <path
                      d="M210.4 511.1 641.3 80.2c22.8-22.8 59.8-22.8 82.6 0 22.8 22.8 22.8 59.8 0 82.6L375.7 511.1l348.3 348.3c22.8 22.8 22.8 59.8 0 82.6-22.8 22.8-59.8 22.8-82.6 0L210.4 511.1 210.4 511.1zM210.4 511.1"
                      p-id="3196"
                    ></path>
                  </svg>
                </div>
                <div class="mobileTimer" aria-label="面试计时">
                  <span class="timerText">{{ timerText }}</span>
                </div>
              </div>

              <div class="remote" aria-label="远端面试官/考官占位">
                <div v-if="candidateRemoteViewId" :id="candidateRemoteViewId" class="candidate-remote-box"></div>
                <div v-else class="ph">
                  <b>候选人画面</b>
                </div>
              </div>
              <div v-if="screenShared" :id="screenPreviewViewId" class="screen-share-pip"></div>
              <div
                class="self"
                :style="selfViewStyle"
                @mousedown="startSelfDrag"
                @touchstart="startSelfDrag"
                @click.stop
              >
                <div id="interviewer-self-view" class="trtc-self-view"></div>
                <div v-if="!camOn" class="selfOffMask" aria-label="摄像头已关闭">
                  摄像头已关闭
                </div>
              </div>
              <!-- <div class="hud">
                <span class="badge ok">身份：已核验</span>
              </div> -->

              <!-- 移动端底部功能栏：点击屏幕切换显隐 -->
              <div
                v-if="isMobile && !roomClosingUiHidden"
                class="mobileBottom"
                :class="{ hide: !mobileControlsVisible }"
                @click.stop
              >
                <div class="mobileControlRow">
                  <button
                    type="button"
                    class="mobileAction"
                    :class="{ off: !camOn, disabled: !stream }"
                    :disabled="!stream"
                    @click.stop="toggleCam"
                  >
                    <span class="mobileActionIcon" aria-hidden="true">
                      <img :src="camOn ? mobileIcons.cameraOn : mobileIcons.cameraOff" alt="" />
                    </span>
                    <span class="mobileActionLabel">{{ camOn ? "摄像头已开" : "摄像头已关" }}</span>
                  </button>
                  <button
                    type="button"
                    class="mobileAction"
                    :class="{ off: !micOn, disabled: !stream }"
                    :disabled="!stream"
                    @click.stop="toggleMic"
                  >
                    <span class="mobileActionIcon" aria-hidden="true">
                      <img :src="micOn ? mobileIcons.micOn : mobileIcons.micOff" alt="" />
                    </span>
                    <span class="mobileActionLabel">{{ micOn ? "麦克风已开" : "麦克风已关" }}</span>
                  </button>
                </div>
                <div class="mobileControlRow mobileControlRowBottom">
                  <button
                    type="button"
                    class="mobileAction mobileActionDanger"
                    @click.stop="handleEndInterviewClick"
                  >
                    <span class="mobileActionIcon" aria-hidden="true">
                      <img :src="mobileIcons.hangup" alt="" />
                    </span>
                    <span class="mobileActionLabel">挂断</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 通用提示浮层 -->
    <div class="toast" :class="{ show: toastVisible }" role="status" aria-live="polite">
      <div class="t">{{ toastTitle }}</div>
      <div class="m">{{ toastMsg }}</div>
    </div>

    <!-- 二次确认弹窗（与下方面试评价弹窗一致：白底 + modal-actions） -->
    <div
      v-if="confirmEndDialog"
      class="modal-overlay confirm-end-overlay"
    >
      <div class="modal-content confirm-end-content" role="dialog" aria-modal="true" aria-labelledby="confirm-end-title">
        <div class="modal-header" style="margin-bottom:0px;">
          <h3 id="confirm-end-title">结束面试确认</h3>
          <button type="button" class="modal-close-btn" aria-label="关闭" @click="confirmEndDialog = false">&times;</button>
        </div>
        <div class="modal-body">
          <p class="confirm-msg">是否结束面试间？确认后将进入打分环节。</p>
        </div>
        <div class="modal-actions">
          <el-button size="small" native-type="button" @click="confirmEndDialog = false">取消</el-button>
          <el-button size="small" native-type="button" @click="openScoreModal">确认</el-button>
        </div>
      </div>
    </div>

    <InterviewEvaluationModal
      :visible="endDialog"
      :scores="scoreForm"
      :errors="scoreErrors"
      :submitting="scoreSubmitting"
      evaluation-stage="other"
      @cancel="cancelEnd"
      @confirm="confirmEnd"
      @update-score="onScoreUpdate"
      @revalidate-field="revalidateScoreField"
    />
  </div>
</template>

<script>
import TRTC from "trtc-sdk-v5";
import { getInterviewRoomSigByUserId, getInterviewRoomStatus } from "@/api/modules/interview/interview";
import {
  enterInterviewRoom,
  getInterviewerEnterTime,
  stopInterviewRoomRecording,
  submitEvaluation,
} from "@/api/modules/interview/interview";
import InterviewEvaluationModal from "./components/InterviewEvaluationModal.vue";

function pad2(n) {
  return String(n).padStart(2, "0");
}

export default {
  name: "InterviewerRoom",
  components: { InterviewEvaluationModal },
  data() {
    return {
      startAt: Date.now(),
      timerTick: null,
      timerText: "00:00",
      hasRecordingStarted: false,
      roomStatusPollTick: null,
      roomStatusPolling: false,

      stream: null,
      micOn: true,
      micToggling: false,
      camOn: true,
      recStatus: "preparing",
      trtc: null,
      roomId: "",

      screenShared: false,
      screenPreviewViewId: "interviewer-screen-preview",

      netOk: navigator.onLine,
      inFocus: true,

      fsRequired: false,
      isFs: false,
      hasBeenFullscreen: false,

      confirmEndDialog: false,
      endDialog: false,

      scoreForm: {
        skill_match: null,
        communication: null,
        problem_solving: null,
        work_thought: null,
        technical_basis: null,
        comprehensive_score: null,
        evaluation_result: null, // 1 通过；0 淘汰
        text_evaluation: null,
      },
      scoreErrors: {},
      scoreValidationActive: false,
      scoreSubmitting: false,
      suppressScoreCancelOnce: false,
      endCheckLoading: false,
      roomClosingUiHidden: false,

      toastVisible: false,
      toastTitle: "提示",
      toastMsg: "—",
      toastTimer: null,

      candidateName: "张三",

      // 远端候选人画面（TRTC）
      candidateUserId: "",
      candidateRemoteViewId: "",

      isMobile: false,
      mobileControlsVisible: true,
      selfViewPos: {
        x: 0,
        y: 0,
      },
      selfViewInited: false,
      selfDragging: false,
      selfDragPointerId: null,
      selfDragStartOffset: {
        x: 0,
        y: 0,
      },
      mobileIcons: {
        cameraOn: require("@/assets/icons/摄像头开@3x.png"),
        cameraOff: require("@/assets/icons/摄像头关@3x.png"),
        screenOff: require("@/assets/icons/演示屏幕@3x.png"),
        screenOn: require("@/assets/icons/演示屏幕开@3x.png"),
        fullscreenEnter: require("@/assets/icons/放大@3x.png"),
        fullscreenExit: require("@/assets/icons/缩小@3x.png"),
        micOn: require("@/assets/icons/麦克风开@3x.png"),
        micOff: require("@/assets/icons/麦克风关@3x.png"),
        hangup: require("@/assets/icons/挂断@3x.png"),
      },
    };
  },
  computed: {
    recStatusClass() {
      return this.recStatus === "fail" ? "bad" : this.recStatus === "ok" ? "ok" : "warn";
    },
    recText() {
      if (this.recStatus === "ok") return "录制：进行中";
      if (this.recStatus === "fail") return "录制：未就绪";
      return "录制：准备中";
    },
    selfViewStyle() {
      return {
        left: `${this.selfViewPos.x}px`,
        top: `${this.selfViewPos.y}px`,
      };
    },
  },
  watch: {},
  async mounted() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);

    const params = this.$route.query;
    if (params.name) this.candidateName = params.name;
    // 按接口/业务约定：roomId = ${interviewId}（不拼接前缀）
    const rawInterviewId = String(params.interviewId || params.interview_id || "").trim();
    this.roomId = rawInterviewId ? rawInterviewId : "";
    // 候选人 userId：userId_${interviewId}
    this.candidateUserId = rawInterviewId ? `userId_${rawInterviewId}` : "";

    // 以“面试登录信息”的形式缓存 interviewId，便于后续提交评价取参
    this.cacheInterviewLoginInfo(this.roomId);

    const shouldStartTimer = await this.initInterviewTimerStartAt();
    this.hasRecordingStarted = shouldStartTimer;
    if (shouldStartTimer) {
      this.startTimer();
    } else {
      this.timerText = "00:00";
    }
    this.startLocalMedia();
    this.$nextTick(() => {
      this.initSelfViewPosition();
    });
    this.onFullscreenChange();

    document.addEventListener("fullscreenchange", this.onFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.onFullscreenChange);
    window.addEventListener("offline", this._onOffline);
    window.addEventListener("online", this._onOnline);
    window.addEventListener("beforeunload", this.stopLocalMedia);

    const handleKeydown = (e) => {
      if (e.key === "Escape") {
        // 评分弹窗打开时，禁止 Esc 关闭，避免误触导致内容丢失
        if (this.endDialog) return;
        // 结束面试确认弹窗打开时，也禁止 Esc 关闭，避免误触
        if (this.confirmEndDialog) return;
      }
    };
    this._handleKeydown = handleKeydown;
    window.addEventListener("keydown", handleKeydown);
  },
  methods: {
    safeNavigateTo(location) {
      const isStringTarget = typeof location === "string";
      const targetPath = isStringTarget ? location : location && location.path;
      const targetName = !isStringTarget && location ? location.name : "";
      if (targetPath && this.$route && this.$route.path === targetPath) return Promise.resolve();
      if (targetName && this.$route && this.$route.name === targetName) return Promise.resolve();
      return this.$router.push(location).catch((err) => {
        const ignoredNavigationErrors = new Set([
          "NavigationDuplicated",
          "NavigationCancelled",
          "NavigationAborted",
          "NavigationRedirected",
        ]);
        if (err && ignoredNavigationErrors.has(err.name)) return;
        throw err;
      });
    },
    async handleEndInterviewClick() {
      if (this.endCheckLoading) return;
      const interviewId = String(this.roomId || "").trim();
      if (!interviewId) {
        this.$message.error("缺少面试ID，无法结束面试");
        return;
      }

      this.endCheckLoading = true;
      try {
        const res = await getInterviewRoomStatus(interviewId);
        const status = Number(res && res.data ? res.data.room_status : res && res.room_status);
        if (status === 2) {
          this.confirmEndDialog = true;
          return;
        }

        await this.$confirm("候选人没有进入面试间，是否暂时离开面试", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.roomClosingUiHidden = true;
        try {
          await enterInterviewRoom(interviewId, 1);
        } catch (e) {
          // 这里不阻断离开面试间流程
          // eslint-disable-next-line no-console
          console.error("[InterviewerRoom][leave-temp] update room status failed:", e);
          // this.toast("房间状态更新失败", (e && e.message) || "无法同步房间状态", 3200);
        }
        this.stopScreenShare();
        if (this.trtc) {
          try {
            await this.trtc.exitRoom();
          } catch (_) {
            // ignore
          } finally {
            try {
              this.uninstallTrtcEventHandlers();
            } catch (_) {}
            this.trtc = null;
          }
        }
        this.stream = null;
        this.micOn = false;
        this.camOn = false;
        this.candidateRemoteViewId = "";
        await this.safeNavigateTo("/interviewer/dashboard/schedule");
      } catch (e) {
        this.roomClosingUiHidden = false;
        if (e !== "cancel" && e !== "close") {
          this.$message.error((e && e.message) || "获取房间状态失败");
        }
      } finally {
        this.endCheckLoading = false;
      }
    },
    clampSelfViewPosition(x, y) {
      const stage = this.$refs.stage;
      const selfEl = this.$el && this.$el.querySelector ? this.$el.querySelector(".self") : null;
      if (!stage || !selfEl) return { x: 0, y: 0 };
      const maxX = Math.max(0, stage.clientWidth - selfEl.offsetWidth);
      const maxY = Math.max(0, stage.clientHeight - selfEl.offsetHeight);
      return {
        x: Math.min(Math.max(0, Number(x) || 0), maxX),
        y: Math.min(Math.max(0, Number(y) || 0), maxY),
      };
    },
    initSelfViewPosition(forceReset = false) {
      this.$nextTick(() => {
        const stage = this.$refs.stage;
        const selfEl = this.$el && this.$el.querySelector ? this.$el.querySelector(".self") : null;
        if (!stage || !selfEl) return;

        if (!this.selfViewInited || forceReset) {
          const horizontalGap = this.isMobile ? 14 : 16;
          const verticalGap = this.isMobile ? 62 : 16;
          const defaultX = Math.max(0, stage.clientWidth - selfEl.offsetWidth - horizontalGap);
          const defaultY = this.isMobile ? verticalGap : Math.max(0, stage.clientHeight - selfEl.offsetHeight - verticalGap);
          const next = this.clampSelfViewPosition(defaultX, defaultY);
          this.selfViewPos = { x: next.x, y: next.y };
          this.selfViewInited = true;
          return;
        }

        const clamped = this.clampSelfViewPosition(this.selfViewPos.x, this.selfViewPos.y);
        this.selfViewPos = { x: clamped.x, y: clamped.y };
      });
    },
    getPointerPosition(e) {
      if (!e) return null;
      if (e.touches && e.touches.length) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      if (e.changedTouches && e.changedTouches.length) {
        return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      }
      if (typeof e.clientX === "number" && typeof e.clientY === "number") {
        return { x: e.clientX, y: e.clientY };
      }
      return null;
    },
    startSelfDrag(e) {
      const pointer = this.getPointerPosition(e);
      if (!pointer) return;
      if (e.type === "mousedown" && e.button !== 0) return;

      const selfEl = this.$el && this.$el.querySelector ? this.$el.querySelector(".self") : null;
      if (!selfEl) return;
      const rect = selfEl.getBoundingClientRect();
      this.selfDragStartOffset = {
        x: pointer.x - rect.left,
        y: pointer.y - rect.top,
      };
      this.selfDragging = true;
      this.selfDragPointerId = e.pointerId != null ? e.pointerId : null;

      window.addEventListener("mousemove", this.onSelfDragMove);
      window.addEventListener("mouseup", this.stopSelfDrag);
      window.addEventListener("touchmove", this.onSelfDragMove, { passive: false });
      window.addEventListener("touchend", this.stopSelfDrag);
      window.addEventListener("touchcancel", this.stopSelfDrag);

      if (e.cancelable) e.preventDefault();
    },
    onSelfDragMove(e) {
      if (!this.selfDragging) return;
      const pointer = this.getPointerPosition(e);
      if (!pointer) return;

      const stage = this.$refs.stage;
      if (!stage) return;
      const stageRect = stage.getBoundingClientRect();

      const nextX = pointer.x - stageRect.left - this.selfDragStartOffset.x;
      const nextY = pointer.y - stageRect.top - this.selfDragStartOffset.y;
      const clamped = this.clampSelfViewPosition(nextX, nextY);
      this.selfViewPos = { x: clamped.x, y: clamped.y };

      if (e.cancelable) e.preventDefault();
    },
    stopSelfDrag() {
      this.selfDragging = false;
      this.selfDragPointerId = null;
      window.removeEventListener("mousemove", this.onSelfDragMove);
      window.removeEventListener("mouseup", this.stopSelfDrag);
      window.removeEventListener("touchmove", this.onSelfDragMove);
      window.removeEventListener("touchend", this.stopSelfDrag);
      window.removeEventListener("touchcancel", this.stopSelfDrag);
    },
    updateIsMobile() {
      if (typeof window === "undefined") {
        this.isMobile = false;
        return;
      }
      this.isMobile = window.innerWidth <= 768;
      if (this.isMobile && this.screenShared) this.stopScreenShare();
      if (!this.isMobile) this.mobileControlsVisible = true;
      this.initSelfViewPosition();
    },
    handleStageTap() {
      if (!this.isMobile) return;
      if (this.endDialog || this.confirmEndDialog) return;
      if (this.selfDragging) return;
      this.mobileControlsVisible = !this.mobileControlsVisible;
    },
    cacheInterviewLoginInfo(interviewId) {
      const id = String(interviewId || "").trim();
      if (!id) return;
      try {
        sessionStorage.setItem("interview_login_info", JSON.stringify({ interview_id: id }));
      } catch (_) {
        // ignore
      }
    },
    getInterviewIdForEvaluation() {
      // 1) 优先从“面试登录信息存储”读取
      const fromStorage = (storage) => {
        try {
          const raw = storage && typeof storage.getItem === "function" ? storage.getItem("interview_login_info") : null;
          if (!raw) return "";
          const parsed = JSON.parse(raw);
          return String(parsed && (parsed.interview_id ?? parsed.interviewId ?? parsed.id) ? parsed.interview_id ?? parsed.interviewId ?? parsed.id : "");
        } catch (_) {
          return "";
        }
      };

      const sId = fromStorage(sessionStorage);
      if (sId) return sId;
      const lId = fromStorage(localStorage);
      if (lId) return lId;

      // 2) fallback：使用路由/房间信息（原型里 interview_id 通常通过路由 query 透传）
      return String(this.roomId || "").trim();
    },
    calcComprehensiveScore() {
      const p = Number(this.scoreForm.skill_match);
      const c = Number(this.scoreForm.communication);
      const r = Number(this.scoreForm.problem_solving);
      const t = Number(this.scoreForm.work_thought);
      const j = Number(this.scoreForm.technical_basis);
      const sum = p + c + r + t + j;
      if (!Number.isFinite(sum)) return 0;
      return Math.round(sum);
    },
    validateScoreField(field) {
      let error = "";
      switch (field) {
        case "skill_match": {
          const raw = this.scoreForm.skill_match;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 35) error = "分数需在 0-35 之间";
          }
          break;
        }
        case "communication": {
          const raw = this.scoreForm.communication;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 20) error = "分数需在 0-20 之间";
          }
          break;
        }
        case "problem_solving": {
          const raw = this.scoreForm.problem_solving;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 15) error = "分数需在 0-15 之间";
          }
          break;
        }
        case "work_thought": {
          const raw = this.scoreForm.work_thought;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 15) error = "分数需在 0-15 之间";
          }
          break;
        }
        case "technical_basis": {
          const raw = this.scoreForm.technical_basis;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 15) error = "分数需在 0-15 之间";
          }
          break;
        }
        case "evaluation_result": {
          const raw = this.scoreForm.evaluation_result;
          if (raw == null || raw === "") error = "请选择面试结果";
          else {
            const v = Number(raw);
            if (!(v === 0 || v === 1)) error = "请选择面试结果";
          }
          break;
        }
        case "text_evaluation": {
          const txt = String(this.scoreForm.text_evaluation || "");
          if (!txt.trim()) error = "请输入面试评语";
          else if (txt.length > 200) error = "面试评语最多 200 个字符";
          break;
        }
        default:
          break;
      }
      if (error) this.$set(this.scoreErrors, field, error);
      else this.$delete(this.scoreErrors, field);
      return !error;
    },
    validateScoreForm() {
      this.scoreValidationActive = true;
      const fields = [
        "skill_match",
        "communication",
        "problem_solving",
        "work_thought",
        "technical_basis",
        "evaluation_result",
        "text_evaluation",
      ];
      let pass = true;
      fields.forEach((field) => {
        const ok = this.validateScoreField(field);
        if (!ok) pass = false;
      });
      return pass;
    },
    revalidateScoreField(field) {
      if (!this.scoreValidationActive) return;
      this.validateScoreField(field);
    },
    onScoreUpdate(payload) {
      const field = payload && payload.field;
      if (!field) return;
      this.$set(this.scoreForm, field, payload.value);
      this.recalculateScoreDerivedFields();
    },
    recalculateScoreDerivedFields() {
      const fields = ["skill_match", "communication", "problem_solving", "work_thought", "technical_basis"];
      const nums = fields.map((key) => {
        const raw = this.scoreForm[key];
        if (raw === "" || raw === null || raw === undefined) return NaN;
        return Number(raw);
      });
      const allValid = nums.every((v) => Number.isFinite(v));
      const total = allValid ? nums.reduce((sum, v) => sum + v, 0) : null;
      this.$set(this.scoreForm, "comprehensive_score", total);
      if (allValid) {
        this.$set(this.scoreForm, "evaluation_result", total >= 60 ? 1 : 0);
      }
    },
    toast(title, msg, ms = 2400) {
      this.toastTitle = title;
      this.toastMsg = msg;
      this.toastVisible = true;
      if (this.toastTimer) window.clearTimeout(this.toastTimer);
      this.toastTimer = window.setTimeout(() => {
        this.toastVisible = false;
        this.toastTimer = null;
      }, ms);
    },
    parseServerTimeToMs(raw) {
      if (raw === null || raw === undefined || raw === "") return null;
      if (raw instanceof Date) {
        const ms = raw.getTime();
        return Number.isFinite(ms) ? ms : null;
      }
      if (typeof raw === "number" && Number.isFinite(raw)) {
        // 后端可能返回秒级时间戳，也可能是毫秒级时间戳
        if (raw > 1e12) return raw;
        if (raw > 1e9) return raw * 1000;
        return null;
      }
      if (typeof raw === "string") {
        const s = raw.trim();
        if (!s) return null;
        if (/^\d+(\.\d+)?$/.test(s)) {
          return this.parseServerTimeToMs(Number(s));
        }
        const direct = Date.parse(s);
        if (Number.isFinite(direct)) return direct;
        const normalized = Date.parse(s.replace(/-/g, "/"));
        return Number.isFinite(normalized) ? normalized : null;
      }
      return null;
    },
    async initInterviewTimerStartAt() {
      this.startAt = Date.now();
      const interviewId = String(this.roomId || "").trim();
      if (!interviewId) return false;
      try {
        const res = await getInterviewerEnterTime(interviewId);
        const data = (res && res.data) || res || {};
        const rawEnterTime =
          data.interviewer_enter_time ??
          data.interviewerEnterTime ??
          data.enter_time ??
          data.enterTime ??
          data.time ??
          data.timestamp;
        const enterAtMs = this.parseServerTimeToMs(rawEnterTime);
        if (!Number.isFinite(enterAtMs) || enterAtMs <= 0) return false;
        // 保护：避免接口异常返回未来时间导致计时显示负数
        this.startAt = Math.min(enterAtMs, Date.now());
        return true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("[InterviewerRoom][getInterviewerEnterTime] failed:", e);
        return false;
      }
    },
    updateTimerText() {
      const sec = Math.max(0, Math.floor((Date.now() - this.startAt) / 1000));
      this.timerText = `${pad2(Math.floor(sec / 60))}:${pad2(sec % 60)}`;
    },
    startTimer() {
      if (this.timerTick) window.clearInterval(this.timerTick);
      this.updateTimerText();
      this.timerTick = window.setInterval(() => {
        this.updateTimerText();
      }, 300);
    },
    stopRoomStatusPolling() {
      if (this.roomStatusPollTick) {
        window.clearInterval(this.roomStatusPollTick);
        this.roomStatusPollTick = null;
      }
      this.roomStatusPolling = false;
    },
    async syncRecordingStateFromServerTime() {
      const shouldStartTimer = await this.initInterviewTimerStartAt();
      if (!shouldStartTimer) return false;
      this.hasRecordingStarted = true;
      this.recStatus = "ok";
      if (!this.timerTick) this.startTimer();
      return true;
    },
    startRoomStatusPolling(interviewId) {
      const normalizedInterviewId = String(interviewId || "").trim();
      if (!normalizedInterviewId || this.hasRecordingStarted) return;
      this.stopRoomStatusPolling();

      const checkRoomStatus = async () => {
        if (this.roomStatusPolling) return;
        this.roomStatusPolling = true;
        try {
          const roomStatusRes = await getInterviewRoomStatus(normalizedInterviewId);
          const roomStatus = Number(
            roomStatusRes && roomStatusRes.data ? roomStatusRes.data.room_status : roomStatusRes && roomStatusRes.room_status
          );
          if (roomStatus !== 2) return;
          const started = await this.syncRecordingStateFromServerTime();
          if (started) {
            this.stopRoomStatusPolling();
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error("[InterviewerRoom][pollRoomStatus] failed:", e);
        } finally {
          this.roomStatusPolling = false;
        }
      };

      checkRoomStatus();
      this.roomStatusPollTick = window.setInterval(checkRoomStatus, 300);
    },
    async startLocalMedia() {
      if (!this.roomId) {
        this.recStatus = "fail";
        // this.toast("缺少参数", "未获取到 interviewId，无法进入音视频房间", 3200);
        return;
      }
      try {
        const params = this.$route.query || {};
        const rawInterviewId = String(params.interviewId || params.interview_id || "").trim();
        if (!rawInterviewId) throw new Error("未获取到 interviewId，无法拉取 TRTC 入房签名");

        // 按接口/业务约定：userId = bossId_${interviewId}
        const requestUserId = `bossId_${rawInterviewId}`;
        const roomId = String(this.roomId);
        const trtcRoomId = Number.parseInt(roomId, 10);
        const finalRoomId = Number.isFinite(trtcRoomId) ? trtcRoomId : roomId;

        // 拉取 sig 配置（sdkAppId / userId / userSig）
        const sigRes = await getInterviewRoomSigByUserId(requestUserId);
        const sigData = sigRes && sigRes.data ? sigRes.data : sigRes;
        const sdkAppId = sigData && sigData.sdkAppId;
        const userId = sigData && sigData.userId;
        const userSig = sigData && sigData.userSig;

        if (!sdkAppId || !userId || !userSig) {
          throw new Error("sig 接口返回缺少入房参数");
        }

        this.trtc = TRTC.create();
        this.installTrtcEventHandlers();
        await this.trtc.enterRoom({
          sdkAppId: parseInt(sdkAppId, 10),
          userId: String(userId),
          userSig: String(userSig),
          roomId: finalRoomId,
        });

        // TRTC 入房成功后，通知候选端该房间状态
        try {
          const roomStatusRes = await getInterviewRoomStatus(rawInterviewId);
          const roomStatus = Number(
            roomStatusRes && roomStatusRes.data ? roomStatusRes.data.room_status : roomStatusRes && roomStatusRes.room_status
          );
          // 已是 1/2 时不重复更新为 1，避免冗余状态写入
          if (roomStatus !== 1 && roomStatus !== 2) {
            await enterInterviewRoom(rawInterviewId, 1);
          }
        } catch (e) {
          // 这里不阻断进入音视频房间流程
          // eslint-disable-next-line no-console
          console.error("[InterviewerRoom][enter] failed:", e);
          // this.toast("房间状态更新失败", (e && e.message) || "无法同步房间状态", 3200);
        }

        await this.trtc.startLocalAudio();
        await this.trtc.startLocalVideo({ view: "interviewer-self-view" });

        this.stream = { trtc: true };
        this.micOn = true;
        this.camOn = true;
        this.recStatus = this.hasRecordingStarted ? "ok" : "preparing";
        if (!this.hasRecordingStarted) {
          this.startRoomStatusPolling(rawInterviewId);
        }
        // this.toast("设备就绪", "已获取 sig 并成功进入音视频房间");
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("[InterviewerRoom][TRTC] enterRoom failed:", e, { rawInterviewId, requestUserId, roomId });
        this.stream = null;
        this.micOn = false;
        this.camOn = false;
        this.recStatus = "fail";
        // this.toast("入房失败", (e && e.message) || "TRTC 入房失败", 3200);
      }
    },
    installTrtcEventHandlers() {
      if (!this.trtc) return;
      this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_AVAILABLE, this.handleRemoteVideoAvailable);
      this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE, this.handleRemoteVideoUnavailable);
      // 本地屏幕共享停止事件（例如用户在浏览器共享浮层里停止）
      this.trtc.on(TRTC.EVENT.SCREEN_SHARE_STOPPED, this.handleScreenShareStopped);
    },
    uninstallTrtcEventHandlers() {
      if (!this.trtc) return;
      this.trtc.off(TRTC.EVENT.REMOTE_VIDEO_AVAILABLE, this.handleRemoteVideoAvailable);
      this.trtc.off(TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE, this.handleRemoteVideoUnavailable);
      this.trtc.off(TRTC.EVENT.SCREEN_SHARE_STOPPED, this.handleScreenShareStopped);
    },
    handleRemoteVideoAvailable(event) {
      const { userId, streamType } = event || {};
      if (!userId || streamType === undefined || streamType === null) return;
      if (!this.candidateUserId || userId !== this.candidateUserId) return;

      // 候选人摄像头只展示主流；屏幕共享（SUB）不在本页 UI 中展示
      const isMain = String(streamType) === String(TRTC.TYPE.STREAM_TYPE_MAIN);
      if (!isMain) return;

      const viewId = `${userId}_${streamType}`;
      this.candidateRemoteViewId = viewId;

      this.$nextTick(async () => {
        try {
          await this.trtc.startRemoteVideo({ userId, streamType, view: viewId });
        } catch (e) {
          // this.toast("拉取候选人画面失败", e?.message || "unknown", 3200);
        }
      });
    },
    handleRemoteVideoUnavailable(event) {
      const { userId, streamType } = event || {};
      if (!userId || streamType === undefined || streamType === null) return;
      if (!this.candidateUserId || userId !== this.candidateUserId) return;

      const isMain = String(streamType) === String(TRTC.TYPE.STREAM_TYPE_MAIN);
      if (!isMain) return;

      const viewId = `${userId}_${streamType}`;
      try {
        this.trtc.stopRemoteVideo({ userId, streamType });
      } catch (_) {}
      if (this.candidateRemoteViewId === viewId) this.candidateRemoteViewId = "";
    },
    handleScreenShareStopped() {
      this.screenShared = false;
    },
    _onOffline() {
      this.netOk = false;
      // this.toast("📶 网络断开", "您已离线，请检查网络连接", 4000);
    },
    _onOnline() {
      this.netOk = true;
      // this.toast("📶 网络恢复", "已重新连接");
    },
    stopLocalMedia() {
      if (this.trtc) {
        this.trtc
          .exitRoom()
          .catch(() => {})
          .finally(() => {
            try {
              this.uninstallTrtcEventHandlers();
            } catch (_) {}
            this.trtc = null;
          });
      }
      this.stream = null;
      this.candidateRemoteViewId = "";
    },
    async toggleMic() {
      if (!this.trtc || !this.stream) return;
      if (this.micToggling) return;
      this.micToggling = true;
      try {
        // 不依赖 muteLocalAudio：部分环境下可能“调用成功但实际上未停止上行音频”
        if (this.micOn) {
          await this.trtc.stopLocalAudio();
          this.micOn = false;
        } else {
          await this.trtc.startLocalAudio();
          this.micOn = true;
        }
        // this.toast("麦克风", this.micOn ? "已开启麦克风" : "已静音");
      } catch (e) {
        // this.toast("麦克风切换失败", e?.message || "unknown", 3200);
      } finally {
        this.micToggling = false;
      }
    },
    async toggleCam() {
      if (!this.trtc || !this.stream) return;
      this.camOn = !this.camOn;

      try {
        if (!this.camOn) {
          await this.trtc.stopLocalVideo();
        } else {
          await this.trtc.startLocalVideo({ view: "interviewer-self-view" });
        }
      } catch (_) {
        // ignore
      }
      // this.toast("摄像头", this.camOn ? "已开启摄像头" : "已关闭摄像头");
    },
    async toggleScreenShare() {
      // 移动端不提供共享屏幕能力，直接忽略触发。
      if (this.isMobile) return;
      if (this.screenShared) {
        this.stopScreenShare();
        return;
      }
      try {
        this.screenShared = true;
        await new Promise((resolve) => this.$nextTick(resolve));

        await this.trtc.startScreenShare({
          view: this.screenPreviewViewId,
          publish: true,
          option: {
            // 原型：不采系统音频
            systemAudio: false,
          },
        });
        // this.toast("共享屏幕", "已开始共享屏幕");
      } catch (e) {
        this.screenShared = false;
        const msg = (e && e.message) || "无法开启屏幕共享";
        // this.toast("共享失败", msg, 3000);
      }
    },
    stopScreenShare() {
      if (!this.screenShared) return;
      try {
        if (this.trtc) this.trtc.stopScreenShare();
      } catch (_) {}
      this.screenShared = false;
      // this.toast("共享屏幕", "已停止共享");
    },
    bindAntiCheatEvents() {
      window.addEventListener("blur", () => {
        this.inFocus = false;
        // this.toast("⚠️ 页面失焦", "切屏事件已记录");
      });
      window.addEventListener("focus", () => {
        this.inFocus = true;
        // this.toast("✅ 焦点恢复", "窗口重新获得焦点");
      });
      document.addEventListener("visibilitychange", () => {
        const hidden = document.visibilityState !== "visible";
        this.inFocus = !hidden;
        if (hidden) {
          // this.toast("⏳ 标签页隐藏", "切换标签页/最小化");
        } else {
          // this.toast("👁️ 标签页可见", "已回到面试标签页");
        }
      });
      window.addEventListener("offline", () => {
        this.netOk = false;
        // this.toast("📶 网络断开", "您已离线，请检查网络连接", 4000);
      });
      window.addEventListener("online", () => {
        this.netOk = true;
        // this.toast("📶 网络恢复", "已重新连接");
      });
      document.addEventListener("fullscreenchange", () => {
        this.onFullscreenChange();
        if (this.fsRequired && !document.fullscreenElement) {
          // this.toast("🔴 全屏退出", "强制全屏模式下退出全屏 (高风险)");
        }
      });
      if (navigator.mediaDevices?.addEventListener) {
        navigator.mediaDevices.addEventListener("devicechange", () => {
          // this.toast("🔌 设备变化", "检测到摄像头/麦克风插拔或切换");
        });
      }
    },
    getFullscreenElement() {
      const d = document;
      return d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement || null;
    },
    onFullscreenChange() {
      this.isFs = !!this.getFullscreenElement();
      if (this.isFs) this.hasBeenFullscreen = true;
      this.initSelfViewPosition();
    },
    async toggleFullscreen() {
      const stage = this.$refs.stage;
      if (!stage) return;
      try {
        if (!this.getFullscreenElement()) {
          const req =
            stage.requestFullscreen ||
            stage.webkitRequestFullscreen ||
            stage.mozRequestFullScreen ||
            stage.msRequestFullscreen;
          if (req) await req.call(stage);
        } else {
          const exit =
            document.exitFullscreen ||
            document.webkitExitFullscreen ||
            document.mozCancelFullScreen ||
            document.msExitFullscreen;
          if (exit) await exit.call(document);
        }
      } catch (_) {
        // this.toast("全屏失败", "浏览器阻止了全屏请求");
      }
      await this.$nextTick();
      this.onFullscreenChange();
      if (this.isMobile && this.isFs) this.mobileControlsVisible = true;
    },
    async openScoreModal() {
      this.confirmEndDialog = false;
      this.roomClosingUiHidden = true;
      if (this.trtc) {
        try {
          await this.trtc.exitRoom();

          // 退出音视频房间后，通知后端更新房间状态：固定 room_status = 0
          try {
            const id = String(this.roomId || "");
            if (id) await enterInterviewRoom(id, 0);
          } catch (e) {
            // 这里不阻断进入打分流程
            // eslint-disable-next-line no-console
            console.error("[InterviewerRoom][enter] end failed:", e);
          }

          // 手动关闭录制（不阻断进入打分流程）
          try {
            const interviewId = String(this.roomId || "");
            if (interviewId) await stopInterviewRoomRecording(interviewId);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("[InterviewerRoom][recording] stop failed:", e);
          }

          this.trtc = null;
          this.stream = null;
          this.micOn = false;
          this.camOn = false;
        } catch (e) {
          // this.toast("退出房间失败", (e && e.message) || "无法退出音视频房间", 3200);
          this.roomClosingUiHidden = false;
          return;
        }
      }

      // 打分弹窗初始化
      this.scoreForm = {
        skill_match: null,
        communication: null,
        problem_solving: null,
        work_thought: null,
        technical_basis: null,
        comprehensive_score: null,
        evaluation_result: null,
        text_evaluation: "",
      };
      this.scoreErrors = {};
      this.scoreValidationActive = true;
      this.scoreSubmitting = false;
      this.endDialog = true;
    },
    cancelEnd() {
      if (this.suppressScoreCancelOnce) {
        this.suppressScoreCancelOnce = false;
        return;
      }
      // el-dialog 在 visible=false 后会触发 close 事件，为避免 cancel 重入导致重复跳转，这里先抑制一次。
      this.suppressScoreCancelOnce = true;
      this.endDialog = false;
      this.closeScoreDialog();
      this.safeNavigateTo({ name: "interviewer-dashboard-schedule" }).finally(() => {
        this.suppressScoreCancelOnce = false;
      });
    },
    closeScoreDialog() {
      this.scoreSubmitting = false;
      this.scoreValidationActive = false;
      this.scoreErrors = {};
    },
    async confirmEnd() {
      if (this.scoreSubmitting) return;
      const valid = this.validateScoreForm();
      if (!valid) return;

      const interview_id = this.getInterviewIdForEvaluation();
      if (!interview_id) {
        this.$message.error("缺少 interview_id，无法提交评价");
        return;
      }

      // 先释放本地资源，再请求接口（不依赖媒体状态）
      this.stopScreenShare();
      this.stopLocalMedia();

      const s = this.scoreForm;
      const p = Number(s.skill_match);
      const c = Number(s.communication);
      const r = Number(s.problem_solving);
      const t = Number(s.work_thought);
      const j = Number(s.technical_basis);
      const comprehensive_score =
        Number.isFinite(Number(s.comprehensive_score))
          ? Number(s.comprehensive_score)
          : p + c + r + t + j;
      const payload = {
        interview_id: Number(interview_id) || interview_id,
        skill_match: p,
        communication: c,
        problem_solving: r,
        work_thought: t,
        technical_basis: j,
        comprehensive_score,
        text_evaluation: String(this.scoreForm.text_evaluation || "").trim(),
        evaluation_result: Number(this.scoreForm.evaluation_result),
      };

      this.scoreSubmitting = true;
      try {
        await submitEvaluation(payload);
        this.$message.success("面试评价已提交");
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("[InterviewerRoom][submitEvaluation] failed:", e);
        this.$message.warning("面试评价提交失败");
      } finally {
        this.scoreSubmitting = false;
        this.suppressScoreCancelOnce = true;
        this.endDialog = false;
        this.closeScoreDialog();
        setTimeout(() => {
          this.safeNavigateTo("/interviewer/dashboard");
        }, 500);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsMobile);
    window.removeEventListener("beforeunload", this.stopLocalMedia);
    window.removeEventListener("offline", this._onOffline);
    window.removeEventListener("online", this._onOnline);
    document.removeEventListener("fullscreenchange", this.onFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.onFullscreenChange);
    this.stopScreenShare();
    this.stopLocalMedia();
    if (this.timerTick) window.clearInterval(this.timerTick);
    this.stopRoomStatusPolling();
    if (this.toastTimer) window.clearTimeout(this.toastTimer);
    if (this._handleKeydown) {
      window.removeEventListener("keydown", this._handleKeydown);
    }
    this.stopSelfDrag();
  },
};
</script>

<style scoped>
:root {
  --bg: #f5f7fa;
  --text: #1a1a2e;
  --muted: #6b7280;
  --line: rgba(0, 0, 0, 0.06);
  --brand: #2563eb;
  --ok: #22c55e;
  --warn: #f59e0b;
  --bad: #ef4444;
  --shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.page {
  min-height: 100%;
  width: 100%;
  background: var(--bg);
}

.page.mobile {
  background: #000;
}

.wrap {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 18px 12px 26px;
  box-sizing: border-box;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 18px;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo {
  width: 90px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: -1px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.back-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  fill: #334155;
  cursor: pointer;
}

.back-icon:hover {
  fill: #2563eb;
}

.back-icon:focus {
  outline: none;
}

.back-icon:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
  border-radius: 4px;
}

.title {
  font-weight: 900;
  font-size: 16px;
}

.indicator-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 13px;
  font-weight: 500;
  color: #1a1a2e;
}

.status-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.status-dot.ok {
  background: var(--ok);
}
.status-dot.warn {
  background: var(--warn);
}
.status-dot.bad {
  background: var(--bad);
}

button {
  border-radius: 11px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #ffffff;
  color: #1a1a2e;
  transition: all 0.1s;
  font-family: inherit;
}
button:hover {
  background: #f8fafc;
}
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
button.danger {
  background: #fee2e2;
  border-color: rgba(239, 68, 68, 0.3);
  color: #b91c1c;
}
button.danger:hover {
  background: #fecaca;
}
button.primary {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  border-color: #2563eb;
  color: #fff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}
button.primary:hover {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.main {
  margin-top: 14px;
}

.card {
  border: 1px solid var(--line);
  border-radius: 20px;
  background: #ffffff;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.cardH {
  padding: 12px 18px;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  background: #f8fafc;
}

.cardH strong {
  font-weight: 900;
}

.btnRow {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.cardB {
  padding: 14px 18px 18px;
}

.stage {
  position: relative;
  aspect-ratio: 16/9;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #0b1120;
}

.remote {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgba(255, 255, 255, 0.86);
}

.remote .ph {
  text-align: center;
  max-width: 560px;
  padding: 18px 22px;
  border-radius: 20px;
  border: 1px dashed rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
}

.remote .ph b {
  font-weight: 950;
  font-size: 1.2rem;
}

.remote .ph p {
  margin: 10px 0 0;
  color: #d1d5db;
  font-size: 13px;
  line-height: 1.6;
}

.remote .remoteVideo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.remote .candidate-remote-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remote .candidate-remote-box video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
}

/* 兼容 TRTC 注入的多层容器，强制候选人画面与面试官画面一致居中 */
.remote .candidate-remote-box /deep/ video,
.remote .candidate-remote-box /deep/ canvas {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  object-position: center center !important;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.self {
  position: absolute;
  left: 16px;
  top: 16px;
  width: min(32%, 240px);
  aspect-ratio: 16/9;
  border-radius: 14px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  background: #1e293b;
  cursor: move;
  touch-action: none;
  z-index: 3;
}

.screen-share-pip {
  position: absolute;
  right: 16px;
  top: 16px;
  width: min(26%, 240px);
  aspect-ratio: 16/9;
  border-radius: 14px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
  background: #1e293b;
  z-index: 2;
}

.screen-share-pip video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.trtc-self-view {
  width: 100%;
  height: 100%;
  background: #1e293b;
}

.selfOffMask {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 10px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
  font-weight: 700;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
}

.hud {
  position: absolute;
  left: 16px;
  bottom: 16px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  pointer-events: none;
}

.badge {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(10, 10, 20, 0.45);
  backdrop-filter: blur(8px);
  color: white;
  font-weight: 500;
}
.badge.ok {
  border-color: rgba(67, 209, 158, 0.5);
  background: rgba(20, 83, 45, 0.4);
}
.badge.warn {
  border-color: rgba(255, 204, 102, 0.5);
  background: rgba(120, 80, 20, 0.4);
}
.badge.bad {
  border-color: rgba(255, 107, 107, 0.5);
  background: rgba(130, 30, 30, 0.4);
}

/* toast */
.toast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 18px;
  max-width: min(980px, calc(100vw - 24px));
  padding: 12px 18px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow);
  display: none;
  color: white;
  z-index: 60;
}
.toast.show {
  display: block;
}
.toast .t {
  font-weight: 900;
}
.toast .m {
  color: #ccc;
  font-size: 12px;
  margin-top: 2px;
}

/* 结束面试二次确认（与面试评价弹窗共用 modal-overlay / modal-content / modal-actions） */
.confirm-end-overlay.modal-overlay {
  z-index: 2090;
}

.confirm-end-content.modal-content {
  width: min(420px, 90vw);
}

.confirm-msg {
  margin: 0;
  color: var(--text);
  line-height: 1.6;
  font-size: 14px;
}

/* 面试评价弹窗（与 InterviewerSchedulePage / InterviewerLayout 一致） */
.eval-score-overlay.modal-overlay {
  z-index: 2100;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 20px;
  width: 500px;
  max-width: 90vw;
  box-shadow: var(--shadow);
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.modal-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  border: none;
  background: transparent;
  color: #909399;
  font-size: 24px;
  line-height: 1;
  padding: 0;
  width: 24px;
  height: 24px;
  margin-top: 1px;
  border-radius: 8px;
  cursor: pointer;
}

.modal-close-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.modal-close-btn:focus {
  outline: none;
}

.modal-close-btn:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
}

.modal-content h3 {
  margin: 0 0 16px;
  font-size: 18px;
  color: var(--text);
}

.modal-content label {
  display: block;
  font-size: 14px;
  color: var(--muted);
  margin-bottom: 4px;
}

.modal-body /deep/ .el-form-item {
  margin-bottom: 0px;
}

.modal-body /deep/ .el-form-item__label {
  line-height: 1.4;
  padding: 0;
  font-size: 14px;
}

.modal-body /deep/ .el-form-item__content {
  line-height: normal;
}

.modal-body /deep/ .el-form-item__error {
  padding-top: 0;
  margin-top: -8px;
  margin-bottom: 8px;
  font-size: 12px;
}

.modal-body input,
.modal-body select {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--line);
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  font-family: inherit;
  background: white;
  color: var(--text);
  box-sizing: border-box;
}

.modal-body input::placeholder {
  color: #c0c4cc;
}

.modal-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.modal-actions > button {
  flex: 1;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  line-height: 1.2;
  margin: 0;
}

.modal-actions > button:first-child {
  background: #ffffff;
  color: #606266;
}

.modal-actions > button:last-child {
  background: var(--brand);
  border-color: var(--brand);
  color: #ffffff;
}

.modal-actions > button:last-child:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 8px;
}

.required-label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.eval-radio-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 10px;
}

.eval-radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text);
  cursor: pointer;
}

.modal-body .eval-radio-group input[type="radio"] {
  width: auto;
  margin-bottom: 0;
  padding: 0;
}

.modal-body /deep/ .el-form-item.is-error .eval-radio-group {
  border: 1px solid #f56c6c;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.modal-body .eval-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--line);
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  font-family: inherit;
  background: #fff;
  color: var(--text);
  resize: vertical;
  box-sizing: border-box;
}

.modal-body /deep/ .el-form-item.is-error .eval-textarea,
.modal-body /deep/ .el-form-item.is-error input {
  border-color: #f56c6c !important;
}

.deskFullscreenBtnImg {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
}

.deskFullscreenBtn /deep/ span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .page {
    min-width: 0;
  }

  .page.mobile {
    height: 100vh;
    overflow: hidden;
  }

  .wrap {
    max-width: 100%;
    padding: 0;
    height: 100vh;
  }

  .top {
    padding: 10px 12px;
    border-radius: 0;
  }

  /* 移动端顶栏在 .stage 内绝对定位，全屏时仍在画面层内 */
  .page.mobile .stageMobileTopBar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 55;
    display: grid;
    grid-template-columns: 42px 1fr 42px;
    align-items: center;
    gap: 0;
    padding: calc(10px + env(safe-area-inset-top, 0px)) 12px 10px;
    background: transparent;
    border: none;
    box-shadow: none;
    transition: transform 0.18s ease, opacity 0.18s ease;
    pointer-events: auto;
  }

  .page.mobile .stageMobileTopBar.hide {
    transform: translateY(-110%);
    opacity: 0;
    pointer-events: none;
  }

  .page.mobile .stageMobileTopBar .brand {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .brand {
    justify-content: flex-start;
  }

  .back-icon.mobileBackIcon {
    width: 28px;
    height: 28px;
    min-width: 28px;
    padding: 6px;
    border-radius: 999px;
    fill: rgba(255, 255, 255, 0.9);
    box-sizing: border-box;
  }

  .mobileTimer {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 78px;
    height: 28px;
    padding: 0 12px;
    border-radius: 999px;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 850;
    letter-spacing: 0.4px;
    user-select: none;
  }

  .mobileTimer .timerText {
    font-variant-numeric: tabular-nums;
  }

  .mobileTopAction {
    justify-self: end;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    box-shadow: none;
    cursor: pointer;
  }

  .mobileTopAction:hover {
    background: transparent;
  }

  .mobileTopAction img {
    width: 22px;
    height: 22px;
    display: block;
    object-fit: contain;
  }

  .mobileTopAction.active {
    opacity: 0.85;
  }

  /* 小屏时尽量让视频区域占屏 */
  .main {
    margin-top: 0;
  }

  .card.mobileCard {
    border-radius: 0;
    border: none;
    box-shadow: none;
    background: transparent;
  }

  .cardB.mobileCardB {
    padding: 0;
  }

  .stage {
    border-radius: 0;
    height: 100vh;
    max-height: 100vh;
    aspect-ratio: auto;
    border: none;
  }

  .self {
    left: auto;
    right: 14px;
    top: calc(14px + env(safe-area-inset-top, 0px) + 34px);
    width: min(31vw, 120px);
    min-width: 104px;
    aspect-ratio: 3 / 5;
    border-radius: 14px;
    border-width: 2px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);
  }

  .screen-share-pip {
    right: 10px;
    top: calc(14px + env(safe-area-inset-top, 0px) + 110px);
    width: min(44%, 200px);
    border-radius: 10px;
  }

  .hud {
    display: none;
  }

  .badge {
    font-size: 11px;
    padding: 5px 10px;
  }

  .toast {
    bottom: 12px;
    padding: 10px 12px;
    border-radius: 12px;
  }

  .mobileBottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 56;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 23px;
    padding: 36px 18px calc(29px + env(safe-area-inset-bottom, 0px));
  }

  .mobileBottom.hide {
    transform: translateY(110%);
    opacity: 0;
    pointer-events: none;
  }

  .mobileControlRow {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 44px;
  }

  .mobileControlRowBottom {
    justify-content: center;
    gap: 0;
  }

  .mobileAction {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-width: 99px;
    padding: 0;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.96);
    box-shadow: none;
  }

  .mobileAction:hover {
    background: transparent;
  }

  .mobileAction.disabled {
    opacity: 0.45;
  }

  .mobileAction.active .mobileActionLabel {
    color: #9fd6ff;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.85), 0 0 8px rgba(30, 100, 180, 0.45);
  }

  .mobileAction.off .mobileActionLabel {
    color: rgba(255, 255, 255, 0.82);
  }

  .mobileAction.off .mobileActionIcon::after {
    content: "";
    position: absolute;
    width: 52px;
    height: 4px;
    border-radius: 999px;
    background: #ff5c5c;
    transform: rotate(-45deg);
  }

  .mobileActionDanger .mobileActionLabel {
    color: #fe645a;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8), 0 0 6px rgba(120, 30, 30, 0.35);
  }

  .mobileActionIcon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 49px;
    height: 49px;
    line-height: 1;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.38);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  }

  .mobileActionIcon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .mobileActionLabel {
    position: relative;
    z-index: 1;
    display: block;
    max-width: 109px;
    font-size: 17px;
    line-height: 1.35;
    text-align: center;
    color: rgba(255, 255, 255, 0.94);
    font-weight: 500;
    letter-spacing: 0.02em;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.75), 0 0 1px rgba(0, 0, 0, 0.6);
  }
}
</style>
